interface ITreatmentInformation {
    physicianName?: string;
    addressLine?: string;
    city?: string;
    state?: string;
    zip?: string;
    firstDateOfCare?: string;
}

class TreatmentInformation implements ITreatmentInformation {
    public physicianName?: string;
    public addressLine?: string;
    public city?: string;
    public state?: string;
    public zip?: string;
    public firstDateOfCare?: string;

    constructor(ti: ITreatmentInformation = {}) {
        this.physicianName = ti.physicianName;
        this.addressLine = ti.addressLine;
        this.city = ti.city;
        this.state = ti.state;
        this.zip = ti.zip;
        this.firstDateOfCare = ti.firstDateOfCare;
    }

    public isValid(): string[] {
        const validations: string[] = [];
        if (this.physicianName === undefined || this.physicianName.length === 0) {
            validations.push('physicianName');
        }
        if (this.addressLine === undefined || this.addressLine.length === 0) {
            validations.push('addressLine');
        }
        if (this.city === undefined || this.city.length === 0) {
            validations.push('city');
        }
        if (this.state === undefined || this.state.length === 0) {
            validations.push('state');
        }
        if (this.zip === undefined || this.zip.length === 0) {
            validations.push('zip');
        }
        if (this.firstDateOfCare === undefined || this.firstDateOfCare.length === 0) {
            validations.push('firstDateOfCare');
        }
        return validations;
    }
}

export default TreatmentInformation;
export { TreatmentInformation, ITreatmentInformation };
